import { Box } from "@chakra-ui/react"

import ModalLeave, { ModalLeaveProps } from "../Modal/ModalLeave"

export default function WithdrawalModalLeave({
  onClose,
  backToProcessTrigger,
}: Pick<ModalLeaveProps, "onClose" | "backToProcessTrigger">) {
  return (
    <Box w="720px" ml="11px" bg="primary.white.100" rounded="24px" p={10}>
      <ModalLeave
        header="Leave withdrawal?"
        stayText="Stay, I'm withdrawing"
        leaveModalText="Leave, not withdrawing"
        onClose={onClose}
        backToProcessTrigger={backToProcessTrigger}
      />
    </Box>
  )
}
